module.exports = __webpack_public_path__ + "static/img/Danny-Vukovic.4ab8cac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Danny-Vukovic.jpg
// module id = mmgv
// module chunks = 0